import { defineStore } from "pinia";

interface DoMoreActionsState {
  actionsResults: any;
  forceGenerate: boolean;
  isLoading: boolean;
}

export const useDoMoreActionsStore = defineStore("doMoreActions", {
  state: (): DoMoreActionsState => ({
    actionsResults: [],
    forceGenerate: false,
    isLoading: false,
  }),
  actions: {
    AddActionResult(result: any) {
      this.actionsResults.push(result);
    },
    popActionResult() {
      return this.actionsResults.pop();
    },
    clearActionResults() {
      this.actionsResults = [];
    },
    setForceGenerate(value: boolean) {
      this.forceGenerate = value;
    },
    setIsLoading(value: boolean) {
      this.isLoading = value;
    },
  },
});
